
import { mapGetters } from 'vuex'
import { EFilter } from '@/helpers/enums'

export default {
  name: 'PoolCategories',

  data() {
    return {
      inputText: '',
      renderedList: []
    }
  },

  computed: {
    ...mapGetters({
      categorizedPoolsList: 'filters/categorizedPoolsList',
      orphanPoolsList: 'filters/orphanPoolsList'
    }),

    selectedPools: {
      get() {
        const selectedList = this.$route.query[EFilter.POOLS]?.split(',') || []

        this.renderLabels(selectedList)

        return this.applyFilter(selectedList)
      },
      async set(arr) {
        this.$emit('before-update')

        const bool = Boolean(arr.length)

        if (bool) {
          const poolsQuery = arr.join(',')

          await this.$updateQuery(this.$route.query, { [EFilter.POOLS]: poolsQuery })
        } else {
          await this.$cleanQuery(this.$route.query, EFilter.POOLS)
        }

        this.$emit('updated')
      }
    }
  },

  methods: {
    applyFilter(data) {
      const uniquePools = [...new Set(data)]

      if (this.categorizedPoolsList.length) {
        const listIds = []

        for (const item of this.categorizedPoolsList) {
          const idsObj = item.children
            .filter((e) => uniquePools.find((i) => Number(i) === e.id))
            .map((e) => ({ ...e, name: this.$t(e.name) }))
          listIds.push(...idsObj.map((i) => i.id))
        }

        return listIds
      }

      if (this.orphanPoolsList.length) {
        const listIds = []
        const idsObj = this.orphanPoolsList
          .filter((e) => uniquePools.find((i) => Number(i) === e.id))
          .map((e) => ({ ...e, name: this.$t(e.name) }))
        listIds.push(...idsObj.map((i) => i.id))
        return listIds
      }
    },

    renderLabels(arr) {
      const makeObj = []

      for (const item of this.categorizedPoolsList) {
        const poolObj = item.children.filter((e) => arr.find((i) => Number(i) === e.id))
        makeObj.push(...poolObj)
      }

      this.renderedList = [...makeObj]
    },

    removePool(id) {
      this.selectedPools = this.selectedPools.filter((e) => e !== id)
    },

    clearFilter() {
      this.inputText = ''
    }
  }
}
